export default __webpack_public_path__ + "static/media/sports-car.76427627.svg";